import { useMemo } from 'react';

import { Box, BoxProps, Heading, HeadingProps } from '@chakra-ui/react';

export type HeadingWithEmphasisProps = {
  text: string;
  headingProps?: Omit<HeadingProps, 'children'>;
  emphasisProps?: BoxProps;
};

export function HeadingWithEmphasis({ text, headingProps, emphasisProps }: HeadingWithEmphasisProps) {
  const [start = null, emphasized = null, end = null] = useMemo(() => {
    // Splits text on **emphasis** markers, capturing any content (including Unicode chars) between double asterisks
    return text?.split(/\*\*([\s\S]+?)\*\*/u) || [];
  }, [text]);
  return (
    <Heading {...headingProps}>
      {start}
      {emphasized && (
        <Box as='span' {...emphasisProps}>
          {emphasized}
        </Box>
      )}
      {end}
    </Heading>
  );
}
